import { render, staticRenderFns } from "./user-sns.vue?vue&type=template&id=478036ae&lang=pug"
import script from "./user-sns.vue?vue&type=script&lang=js"
export * from "./user-sns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports